// extracted by mini-css-extract-plugin
export default {"Container":"Games_Container__yCAr2","Header":"Games_Header__-q5LK","Img":"Games_Img__AJiMo","p":"Games_p__EO8t4","h2":"Games_h2__Ghmgw"};